import React from 'react';
import PropTypes from 'prop-types';
import {map} from 'lodash';
import {Link} from 'react-router-dom';
import StudentInformationCard from './StudentInformationCard';

export default class ManageStudents extends React.Component {
  static propTypes = {
    potentialConnectedUsers: PropTypes.array,
    userConnections: PropTypes.array,
    deleteUserConnection: PropTypes.func,
    deletePotentialConnectedUser: PropTypes.func,
  };

  render() {
    const {
      potentialConnectedUsers,
      userConnections,
      deleteUserConnection,
      deletePotentialConnectedUser,
    } = this.props;

    return (
      <div className="manage-students-wrapper">
        <div className="manage-students-header">
          <h3 className="manage-students-title">My Future College Students</h3>
          <Link
            className="add-student-button"
            replace
            to={{
              pathname: '/account-settings/manage-students/connect-with-student',
              state: {skipScrolling: true},
            }}
          >
            + Add Student
          </Link>
        </div>
        {map(userConnections, (connection) => (
          <StudentInformationCard
            {...connection.connectedUser}
            key={connection.connectedUser._id}
            handleRemoveClick={() => deleteUserConnection(connection)}
          />
        ))}
        {map(potentialConnectedUsers, (potentialConnectedUser) => (
          <StudentInformationCard
            {...potentialConnectedUser}
            key={potentialConnectedUser._id}
            handleRemoveClick={() => deletePotentialConnectedUser(potentialConnectedUser)}
          />
        ))}
      </div>
    );
  }
}
